import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataSourceCategorySubformComponent } from '../../jobs-tab/add-job-dialog/data-source-category-subform/data-source-category-subform.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import IZoningCode = ZoningAPI.IZoningCode;
import { IIndexationTaskParams } from '../../../interfaces/indexation-task-params.interface';

@Component({
    standalone: false,
    selector: 'app-zc-indexing-process-settings-dialog',
    templateUrl: './zc-indexing-process-settings-dialog.component.html',
    styleUrls: ['./zc-indexing-process-settings-dialog.component.scss']
})
export class ZcIndexingProcessSettingsDialogComponent implements OnInit {
    indexationTaskSettingsForm: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IZoningCode,
        private formBuilder: FormBuilder,
        private cdRef: ChangeDetectorRef,
        public dialogRef: MatDialogRef<IIndexationTaskParams>
    ) {}

    ngOnInit(): void {
        this.indexationTaskSettingsForm = this.formBuilder.group({
            saveRawIds: false
        });

        this.indexationTaskSettingsForm.statusChanges.subscribe(() => this.cdRef.markForCheck());
    }

    formInitialized(name: string, form: FormGroup) {
        setTimeout(() => {
            this.indexationTaskSettingsForm.setControl(name, form);
        }, 0);
    }

    onSubmit() {
        this.dialogRef.close({
            saveRawIds: this.indexationTaskSettingsForm.value['saveRawIds'],
            dataSourceCategories: JSON.parse(
                DataSourceCategorySubformComponent.getQueryParams(
                    this.indexationTaskSettingsForm.value['dataSourceCategories']
                )
            )
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}
